export const DEMO_SESSION_STATUS = "demo";
export const DEMO_MODE_HEADER = "x-wypelnijpdf-demo";

export function isDemoSessionStatus(status: string | null | undefined) {
  return status === DEMO_SESSION_STATUS;
}

export function isDemoModeHeader(value: string | null | undefined) {
  return value === "1" || value?.toLowerCase() === "true";
}

export function demoDownloadBlockedMessage() {
  return "Tryb demo pozwala sprawdzić edycję PDF, ale nie pozwala pobrać przygotowanego pliku.";
}
